export default "__VITE_ASSET__BvuwgrCE__"